import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, EnumDecoder, field, IntegerDecoder, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
import { PaymentMethod } from "./PaymentMethod";
import { TransferSettings } from "./webshops/TransferSettings";
export class PayconiqAccount extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.merchantId = null;
        this.profileId = null;
        this.name = null;
        this.iban = null;
        this.callbackUrl = null;
        /**
         * Temorary stored whether this payconiq API key is probably still on the old system
         */
        this.legacyApi = false;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], PayconiqAccount.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], PayconiqAccount.prototype, "apiKey", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PayconiqAccount.prototype, "merchantId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PayconiqAccount.prototype, "profileId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PayconiqAccount.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PayconiqAccount.prototype, "iban", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PayconiqAccount.prototype, "callbackUrl", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], PayconiqAccount.prototype, "legacyApi", void 0);
/**
 * Should remain private
 */
export class PrivatePaymentConfiguration extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Warning: internal id is used instead of the stripe id
         */
        this.stripeAccountId = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 174 })
], PrivatePaymentConfiguration.prototype, "stripeAccountId", void 0);
export class AdministrationFeeSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * In pertenthousand ‱
         * 10 = 0,1% discount
         * 1 = 0,01% discount
         */
        this.percentage = 0;
        /**
         * In cents
         */
        this.fixed = 0;
        this.zeroIfZero = true;
    }
    calculate(price) {
        if (price <= 0 && this.zeroIfZero) {
            return 0;
        }
        return Math.round(price * this.percentage / 10000) + this.fixed;
    }
    isEqual(other) {
        return this.percentage === other.percentage && this.fixed === other.fixed && this.zeroIfZero === other.zeroIfZero;
    }
    isZero() {
        return this.percentage === 0 && this.fixed === 0;
    }
}
__decorate([
    field({ decoder: IntegerDecoder })
], AdministrationFeeSettings.prototype, "percentage", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], AdministrationFeeSettings.prototype, "fixed", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 228 })
], AdministrationFeeSettings.prototype, "zeroIfZero", void 0);
export class PaymentConfiguration extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.transferSettings = TransferSettings.create({});
        this.paymentMethods = [];
        this.administrationFee = AdministrationFeeSettings.create({});
    }
}
__decorate([
    field({ decoder: TransferSettings })
], PaymentConfiguration.prototype, "transferSettings", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(new EnumDecoder(PaymentMethod)) })
], PaymentConfiguration.prototype, "paymentMethods", void 0);
__decorate([
    field({ decoder: AdministrationFeeSettings })
], PaymentConfiguration.prototype, "administrationFee", void 0);
//# sourceMappingURL=PaymentConfiguration.js.map